import type LegacyModal from '@orientaction/components/ModalCardHarmony';
import { ComponentProps } from 'react';
import { publicSvgPath } from '@orientaction/utils';
import RedesignImage from '../../../../../shared/components/RedesignImage';
import DetailModal, { Advice, ContentList, Html, QuoteIcon } from '.';
import { useDetailModalStyles } from './DetailModal.styles';

const HarmonyDetailModal = (props: ComponentProps<typeof LegacyModal>) => {
  const {
    titleAd,
    imgAd,
    descriptionAd,
    open,
    onCancel,
    label,
    img,
    color,
    value,
    citation,
    text1,
    listEmploi1,
    title,
    text2,
    listeAccordeon,
  } = props;
  const classes = useDetailModalStyles();
  const ad = (withImage = false) => (
    <aside className={classes.border}>
      <h3>{titleAd}</h3>
      {withImage && imgAd && (
        <RedesignImage
          src={`${publicSvgPath}/${imgAd}`}
          alt="Exercice d’observation : où est le panda ?"
          className={classes.adImage}
        />
      )}
      <Html text={descriptionAd} />
    </aside>
  );
  return (
    <DetailModal
      open={open}
      onCancel={onCancel}
      label={label}
      img={img}
      color={color}
      value={value}
      introduction={
        <blockquote className={classes.quote}>
          <QuoteIcon />
          <Html text={citation} />
        </blockquote>
      }>
      <section className={classes.section}>
        <h3>Définition de la soft skill</h3>
        <div className={classes.columns}>
          <Html text={text1} />
          <div>
            <h3>Fonctions et/ou métiers dans lesquels elle est déterminante</h3>
            <ContentList items={listEmploi1} />
          </div>
        </div>
      </section>
      <section className={classes.panel} style={{ backgroundColor: color }}>
        <h2>{title}</h2>
        {Array.isArray(text2) ? (
          <div className={classes.columns}>
            {text2.map(text => (
              <Html key={text} text={text} />
            ))}
          </div>
        ) : (
          <div className={classes.flowingText}>
            <Html text={text2} />
          </div>
        )}
        <div className={classes.accordions}>
          {listeAccordeon?.map((item: any, index: number) => (
            <Advice key={item.title} index={index + 1} title={item.title}>
              <div className={classes.columns}>
                <div>
                  <Html text={item.description[0]} />
                  {label === 'Vision' && index === 0 && ad(true)}
                  {label === 'Créativité' && index === 2 && ad()}
                </div>
                <div>
                  <Html text={item.description[1]} />
                  {['Résolution de problèmes', 'Confiance'].includes(label) && index === 0 && ad()}
                  {label === 'Audace' && index === 2 && ad()}
                </div>
              </div>
            </Advice>
          ))}
        </div>
      </section>
    </DetailModal>
  );
};

export default HarmonyDetailModal;
